var _style, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlluBgLeanBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 542.51 317.58",
    style: {
      enableBackground: "new 0 0 542.51 317.58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5CCCFF;}\n\t.st1{fill:#5DCCFF;}\n\t.st2{fill:#1D1D1B;}\n\t.st3{fill:#1E1E1C;}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,213.48c24.69,46.03,25.42,55.92,61.01,77.63c13.93,8.5,56.79,28.66,91.12,24.35 c50.2-6.3,71.72-15.4,104.07-33.16c38.76-21.28,65.89-16.62,109.12-7.39c21.21,4.53,41.97,12.5,63.68,12.56 c32.4,0.09,63.72-18.71,80.63-46.18c16.92-27.48,19.71-62.53,9.47-93.02c-6.05-18.01-16.8-34.95-32.69-45.49 c-14.8-9.82-32.85-13.43-50.51-15.8c-23.68-3.17-47.62-4.49-71.52-3.92c-43.37,1.03-82.07,38.66-121.21,20.19 c-17.16-8.1-32.99-8.98-51-15c-57.44-19.19-97.43-24.78-153.37-17.49c-32.64,4.26-46.1,29.64-51.57,65.02 C-1.32,167.95,1.08,184.91,16.4,213.48z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M477.51,49.78c1.48-11.47,8.97-19.26,19.49-24.05c11.52-5.25,25.99,2.58,30.94,14.23 c4.95,11.65,2.12,25.37-3.94,36.48c-1,1.84-2.13,3.68-3.8,4.95c-1.91,1.45-4.35,2.01-6.73,2.23c-9.89,0.91-19.53-3.44-27.91-8.77 c-5.88-3.74-12.12-10.06-9.8-16.64C475.74,58.2,477.07,53.2,477.51,49.78z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.14,23.61c2.36,1.59,5.49-0.23,7.57-2.17c2.96-2.76,5.66-6.12,6.32-10.12c0.16-0.96,0.19-1.98-0.19-2.89 c-0.33-0.79-0.94-1.42-1.56-2.01c-3.77-3.53-8.89-6.05-14-5.29s-9.68,5.67-8.78,10.76c0.82,4.64,3.55,7.94,7.98,9.56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluBgLeanBack);
export default __webpack_public_path__ + "static/media/illu_bg_lean_back.57fc454410ee606855d28dccc1b188ad.svg";
export { ForwardRef as ReactComponent };